import { render, staticRenderFns } from "./RelCriticasPlanoSaude.vue?vue&type=template&id=0741f2a7"
import script from "./RelCriticasPlanoSaude.vue?vue&type=script&lang=ts"
export * from "./RelCriticasPlanoSaude.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports